import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              最新爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-2">实时更新的热门黑料文章</p>
          </div>
          <a
            href="#updates"
            className="text-sm text-primary-600 font-medium hover:text-primary-700 whitespace-nowrap hidden sm:inline-flex items-center gap-1 cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((card) => (
            <article
              key={card.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-[10px] font-bold rounded whitespace-nowrap">
                    {card.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors mb-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-4">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views} 阅读
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}